import { notifications } from "@mantine/notifications";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { api } from "#app/http/api";
import { logger } from "#app/monitoring/Logger";
import { showSuccessToast } from "#app/notifications";
import { ProductTypeType } from "shared";

import { productsQuery } from "../infra/products.query";

export const useCreateProduct = () => {
  const queryClient = useQueryClient();

  const { mutateAsync: createProduct, isPending } = useMutation({
    mutationFn: async (productData: {
      name: string;
      price: number;
      fixedPrice?: number;
      type: ProductTypeType;
    }) => {
      const response = await api.products.create.mutation({
        body: productData,
      });

      if (response.status !== 201) {
        throw new Error("Failed to create product");
      }

      return response.body;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries(productsQuery());
      showSuccessToast({
        title: "Succès",
        message: "Le produit a été créé avec succès",
      });
    },
    onError: (error) => {
      notifications.show({
        title: "Erreur",
        message: "Impossible de créer le produit",
        color: "red",
      });

      if (error instanceof AxiosError) {
        logger.error("Failed to create product:", error);
      }
    },
  });

  return {
    createProduct,
    isPending,
  };
};
